import { isNullOrUndefined } from "../../../common/utils";

export function membershipConditionErrorResponse(errorCode, conditionId, message) {
  if (isNullOrUndefined(errorCode)) {
    return {};
  } else {
    return { errorCode, conditionId, message };
  }
}

export function validateMembershipCondition(conditionNode) {
  if (isNullOrUndefined(conditionNode)) {
    return {};
  }

  let error = conditionNode.returnMembershipConditionErrorCode();
  if (!isNullOrUndefined(error.errorCode)) {
    return error;
  }

  if (conditionNode.isSingleOperand() === false) {
    const operands = conditionNode.getOperands();
    for (let count = 0; count < operands.length; count++) {
      error = validateMembershipCondition(operands[count]);
      if (!isNullOrUndefined(error.errorCode)) {
        return error;
      }
    }
  }
  return {};
}
